var e, t;
function s() {
  if (t) return e;
  t = 1;
  return e = class {
    constructor(e) {
      if (this.distance = e.distance, this.address = {}, e.address && (this.address.street = e.address.street, this.address.city = e.address.city, this.address.state_abbreviation = e.address.state_abbreviation, this.address.zipcode = e.address.zipcode, this.address.source = e.address.source), this.coordinate = {}, e.coordinate) if (this.coordinate.latitude = e.coordinate.latitude, this.coordinate.longitude = e.coordinate.longitude, this.coordinate.accuracy = e.coordinate.accuracy, 1 === e.coordinate.license) this.coordinate.license = "SmartyStreets Proprietary";else this.coordinate.license = "SmartyStreets";
    }
  };
}
export { s as __require };